export const isDateFilter = (fieldId: string) => fieldId.includes('Date');
